import { render, staticRenderFns } from "./VPSForgotUserIdUserDetails.vue?vue&type=template&id=1f093e2b&scoped=true"
import script from "./VPSForgotUserIdUserDetails.vue?vue&type=script&lang=js"
export * from "./VPSForgotUserIdUserDetails.vue?vue&type=script&lang=js"
import style0 from "./VPSForgotUserIdUserDetails.vue?vue&type=style&index=0&id=1f093e2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f093e2b",
  null
  
)

export default component.exports